/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Template_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "{name} will be deleted. This cannot be undone." |
*
* @param {Settings_Template_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_delete_description = /** @type {((inputs: Settings_Template_Delete_DescriptionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Delete_DescriptionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} wordt verwijderd. Dat kan je niet ongedaan maken.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} sera supprimé. Cette action est définitive.`)
	return /** @type {LocalizedString} */ (`${i?.name} will be deleted. This cannot be undone.`)
});